import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { createRootReducer, ApplicationState } from './store';
import { History } from 'history';
import thunk from 'redux-thunk';
import { offlineMiddleware } from '../middleware/offlineMiddleware';

export const history = createBrowserHistory();

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(
  history: History,
  preloadedState?: ApplicationState
) {
  const store = createStore(
    createRootReducer(history),
    preloadedState,
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history),
        thunk,
        offlineMiddleware
      )
    )
  );

  return store;
}
